import Vue from 'vue'
import Router from 'vue-router'
import Form from '@/components/Form'
import Monitoring from '@/components/Monitoring'
import Login from '@/components/Login'
import Thanks from '@/components/Thanks'
import store from '@/store'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/monitoring'
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      beforeEnter: (to, from, next) => {
        store.dispatch('logout').then(() => {
          next('login')
        })
      }
    },
    {
      path: '/monitoring',
      name: 'monitoring',
      component: Monitoring,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/form',
      name: 'form',
      component: Form,
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/thanks',
      name: 'thanks',
      component: Thanks
    }
  ]
})

// Redirect the routes if user is authenticated
router.beforeEach((to, from, next) => {
  if (window.location.href.indexOf('localhost:8080') !== -1) {
    console.warn('Skipping auth in localhost!')
    next()
    return
  }

  const isAuthenticated = store.getters.isAuthenticated
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !isAuthenticated) {
    console.log('user not loged in, redirecting to login')
    next({path: 'login', query: Object.assign(to.query, {nextRoute: to.path})})
  } else {
    // console.log('auth ok, continue')
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js